import Cookies from "js-cookie";
import TenantAPI from "./TenantAPI";
import API from "./API";
import { ShareAuthType } from "../../components/PageView/ShareScreenDrawer/ShareScreenDrawer";

export default class SharedScreenAPI {
  static async createSharedScreen(
    workspaceID: string,
    viewID: string | undefined,
    authentication: ShareAuthType,
    password: string,
    recordID: string | undefined,
    recordModule: string | undefined,
    parentPageID: string | undefined,
    parentViewID: string | undefined,
    documentID: string | undefined
  ) {
    // If a parent view ID is provided, don't pass the parent page ID to the API
    if (parentViewID) {
      parentPageID = undefined;
    }

    viewID = documentID ? "document" : viewID;

    return API._bearerRequest(
      "post",
      `/tenant/workspaces/${workspaceID}/pages/shared/views/${
        viewID || "page" // If not viewID is provided, share as page
      }/share`,
      {
        recordID,
        authentication,
        password,
        recordModule,
        parentPageID,
        parentViewID,
        documentID,
      },
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static async updateSharedScreen(
    workspaceID: string,
    viewID: string | undefined,
    authentication: ShareAuthType,
    password: string,
    recordID?: string,
    pageID?: string,
    documentID?: string
  ) {
    viewID = documentID ? "document" : viewID;

    return API._bearerRequest(
      "put",
      `/tenant/workspaces/${workspaceID}/pages/shared/views/${
        viewID || "page"
      }/share`,
      { recordID, authentication, password, pageID, documentID },
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static async unshareScreen(
    workspaceID: string,
    viewID: string | undefined,
    recordID: string | undefined,
    parentPageID: string | undefined,
    parentViewID: string | undefined,
    documentID?: string
  ) {
    viewID = documentID ? "document" : viewID;

    return API._bearerRequest(
      "put",
      `/tenant/workspaces/${workspaceID}/pages/shared/views/${
        viewID || "page"
      }/deleteSharedView`,
      { recordID, parentPageID, parentViewID, documentID },
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static async unshareScreens(sharedIds: string[], moduleAPIName: string) {
    return API?._bearerRequest(
      "delete",
      `/share/records/bulk-delete/${moduleAPIName}`,
      { RecordIds: sharedIds },
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  // For getting shared views AND pages.
  static async getSharedScreenInTenant({
    workspaceID,
    viewID,
    recordID,
    pageID,
    documentID,
  }: {
    workspaceID: string;
    viewID: string | undefined;
    recordID: string | undefined;
    pageID: string | undefined;
    documentID: string | undefined;
  }) {
    viewID = documentID ? "document" : viewID;

    return API._bearerRequest(
      "put",
      `/tenant/workspaces/${workspaceID}/pages/shared/views/${
        viewID || "page" // If no viewID is provided, we are sharing a page
      }/getSharedView`,
      { recordID, pageID, documentID },
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static async getSharedView(
    tenantID: string,
    sharedViewID: string,
    recordID: string | undefined,
    password?: string
  ) {
    return API._bearerRequest(
      "put",
      `/tenant/shared/views/${sharedViewID}/getSharedView/${tenantID}`,
      { password, recordID },
      Cookies.get(`authenticationToken`)
    );
  }

  static async getSharedPage(
    tenantID: string,
    sharedPageID: string,
    password?: string
  ) {
    return API._bearerRequest(
      "put",
      `/tenant/shared/views/${sharedPageID}/getSharedPage/${tenantID}`,
      { password },
      Cookies.get(`authenticationToken`)
    );
  }

  static async getSharedPageView(
    tenantID: string,
    sharedPageID: string,
    viewID: string,
    password?: string
  ) {
    return API._bearerRequest(
      "put",
      `/tenant/shared/views/${sharedPageID}/getSharedPageView/${tenantID}`,
      { password, viewID },
      Cookies.get(`authenticationToken`)
    );
  }

  static async searchRecordWithSharedView({
    sharedViewID,
    tenantID,
    moduleAPIName,
    query,
  }: {
    sharedViewID: string;
    tenantID: string;
    moduleAPIName: string;
    query: any;
  }) {
    return API._bearerRequest(
      "put",
      `/tenant/shared/views/${sharedViewID}/searchWithSharedView/${tenantID}/${moduleAPIName}`,
      {
        Query: query,
      },
      Cookies.get(`authenticationToken`)
    );
  }

  static async searchRecordWithSharedPage({
    sharedPageID,
    viewID,
    tenantID,
    moduleAPIName,
    query,
  }: {
    sharedPageID: string;
    viewID: string;
    tenantID: string;
    moduleAPIName: string;
    query: any;
  }) {
    return API._bearerRequest(
      "put",
      `/tenant/shared/views/${sharedPageID}/searchWithSharedPage/${tenantID}/${moduleAPIName}`,
      {
        ViewID: viewID,
        Query: query,
      },
      Cookies.get(`authenticationToken`)
    );
  }

  static async searchRecordWithSharedRecordPage({
    sharedRecordPageID,
    viewID,
    tenantID,
    moduleAPIName,
    query,
  }: {
    sharedRecordPageID: string;
    viewID: string;
    tenantID: string;
    moduleAPIName: string;
    query: any;
  }) {
    return API._bearerRequest(
      "put",
      `/tenant/shared/views/${sharedRecordPageID}/searchWithSharedRecordPage/${tenantID}/${moduleAPIName}`,
      {
        ViewID: viewID,
        Query: query,
      },
      Cookies.get(`authenticationToken`)
    );
  }

  static async getSharedDoc(
    tenantID: string,
    sharedDocID: string,

    password?: string
  ) {
    return API._bearerRequest(
      "put",
      `/tenant/shared/views/${sharedDocID}/getSharedDocument/${tenantID}`,
      { password },
      Cookies.get(`authenticationToken`)
    );
  }
}
